/* dsr-kit.js — interazioni PDP Protocollo Drenaggio (quiz, simulatore, contatori) */
(function () {
  "use strict";

  /* ---------- Animated counters ---------- */
  function animateCount(el) {
    var to = parseFloat(el.getAttribute("data-to"));
    var dec = parseInt(el.getAttribute("data-dec") || "0", 10);
    var suf = el.getAttribute("data-suffix") || "";
    var pre = el.getAttribute("data-prefix") || "";
    var dur = 1200, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = to * eased;
      el.textContent = pre + val.toFixed(dec).replace(".", ",") + suf;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = pre + to.toFixed(dec).replace(".", ",") + suf;
    }
    requestAnimationFrame(step);
  }
  if ("IntersectionObserver" in window) {
    var co = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { animateCount(e.target); co.unobserve(e.target); } });
    }, { threshold: 0.4 });
    document.querySelectorAll(".dsr-count").forEach(function (el) { co.observe(el); });
  } else {
    document.querySelectorAll(".dsr-count").forEach(function (el) {
      el.textContent = (el.getAttribute("data-prefix") || "") + el.getAttribute("data-to") + (el.getAttribute("data-suffix") || "");
    });
  }

  /* ---------- Quiz ---------- */
  var quizState = { step: 0, score: 0, total: 3 };
  window.dsrqStart = function () {
    quizState = { step: 1, score: 0, total: 3 };
    showQuizStep(1);
  };
  function showQuizStep(n) {
    document.querySelectorAll(".dsrq-step").forEach(function (s) { s.classList.remove("active"); });
    var el = document.querySelector('.dsrq-step[data-step="' + n + '"]');
    if (el) el.classList.add("active");
    var fill = document.getElementById("dsrqFill");
    if (fill) fill.style.width = ((n - 1) / quizState.total * 100) + "%";
  }
  window.dsrqAns = function (btn, score) {
    quizState.score += score;
    quizState.step++;
    if (quizState.step <= quizState.total) showQuizStep(quizState.step);
    else showQuizResult();
  };
  function showQuizResult() {
    document.querySelectorAll(".dsrq-step").forEach(function (s) { s.classList.remove("active"); });
    var fill = document.getElementById("dsrqFill"); if (fill) fill.style.width = "100%";
    var res = document.querySelector('.dsrq-step[data-step="result"]');
    if (res) res.classList.add("active");
    var s = quizState.score;
    var emoji = document.getElementById("dsrqEmoji");
    var title = document.getElementById("dsrqTitle");
    var txt = document.getElementById("dsrqText");
    if (s >= 6) {
      if (emoji) emoji.textContent = "🌿";
      if (title) title.textContent = "Il Protocollo è pensato per te.";
      if (txt) txt.innerHTML = "I tuoi segnali — pesantezza serale, caviglie gonfie, poche occasioni di movimento — sono proprio quelli su cui il Protocollo lavora. <strong>Abbina le due formule alle buone abitudini</strong> e dai ai polpacci una mano ogni giorno.";
    } else if (s >= 3) {
      if (emoji) emoji.textContent = "💧";
      if (title) title.textContent = "Vale la pena provarlo.";
      if (txt) txt.innerHTML = "Qualche segnale c'è. Un ciclo del Protocollo, insieme a movimento e idratazione, è il modo giusto per <strong>capire come risponde il tuo corpo</strong>, senza promesse miracolose.";
    } else {
      if (emoji) emoji.textContent = "🍃";
      if (title) title.textContent = "Sei abbastanza in equilibrio.";
      if (txt) txt.innerHTML = "I segnali sono pochi. Se vuoi un supporto nei mesi più caldi o nei periodi più statici, il Protocollo funziona anche <strong>a cicli</strong>. Altrimenti, parti dalle abitudini del Dossier.";
    }
  }
  window.dsrqRestart = function () { window.dsrqStart(); };

  /* ---------- Simulatore scorta ---------- */
  var PRICES = { 1: { tot: 64.80, disc: 0 }, 2: { tot: 116.64, disc: 10 }, 3: { tot: 165.24, disc: 15 } };
  var SINGLE = 84.80; // valore due integratori singoli
  function eur(v) { return "€" + v.toFixed(2).replace(".", ","); }
  window.dsrSim = function (q) {
    q = parseInt(q, 10);
    var p = PRICES[q];
    var perUnit = p.tot / q;
    var fullValue = SINGLE * q;
    var saving = fullValue - p.tot;
    var months = q * 2; // ~2 mesi per protocollo (60+60 cpr)
    var set = function (id, val) { var e = document.getElementById(id); if (e) e.textContent = val; };
    var discEl = document.getElementById("dsrSimDisc");
    if (discEl) {
      if (p.disc > 0) { discEl.textContent = "−" + p.disc + "%"; discEl.style.display = ""; }
      else { discEl.style.display = "none"; }
    }
    set("dsrSimQty", q + (q === 1 ? " Protocollo" : " Protocolli"));
    set("dsrSimTotal", eur(p.tot));
    set("dsrSimPer", eur(perUnit) + " cad.");
    set("dsrSimMonths", "≈ " + months + " mesi");
    set("dsrSimSave", eur(saving));
    set("dsrSimDisc", p.disc > 0 ? "−" + p.disc + "%" : "—");
    // bar fill: savings vs max (3-pack saving)
    var maxSave = SINGLE * 3 - PRICES[3].tot;
    var bar = document.getElementById("dsrSimBar");
    if (bar) bar.style.width = Math.max(8, (saving / maxSave) * 100) + "%";
    document.querySelectorAll(".dsr-simdot").forEach(function (d) {
      d.classList.toggle("on", parseInt(d.getAttribute("data-q"), 10) <= q);
    });
  };
  window.dsrSimAdd = function () {
    var r = document.getElementById("dsrSimRange");
    var q = r ? parseInt(r.value, 10) : 1;
    if (typeof window.ksmSelectQty === "function") window.ksmSelectQty(q);
    var t = document.querySelector(".dsr-pricing");
    if (t) t.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  // init simulator default
  try { if (document.getElementById("dsrSimRange")) window.dsrSim(document.getElementById("dsrSimRange").value || 2); } catch (e) {}

  /* ---------- Ingredient slider ---------- */
  window.dsrIngScroll = function (dir) {
    var t = document.getElementById("dsrIngTrack");
    if (!t) return;
    var card = t.querySelector(".dsr-ingp-card");
    var step = card ? card.offsetWidth + 20 : 320;
    t.scrollBy({ left: dir * step, behavior: "smooth" });
  };

  /* ---------- Sticky gallery (translate-based, robust vs theme overflow) ---------- */
  (function () {
    var gal = document.getElementById("dsrGallery");
    var hero = document.querySelector(".dsr-hero");
    if (!gal || !hero) return;
    var OFFSET = 24;
    var ticking = false;
    function apply() {
      ticking = false;
      if (window.innerWidth <= 980) { gal.style.transform = ""; return; }
      var maxShift = hero.offsetHeight - gal.offsetHeight - 24;
      if (maxShift <= 8) { gal.style.transform = ""; return; }
      var shift = OFFSET - hero.getBoundingClientRect().top;
      if (shift < 0) shift = 0;
      if (shift > maxShift) shift = maxShift;
      gal.style.transform = "translateY(" + Math.round(shift) + "px)";
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", apply);
    setTimeout(apply, 80); apply();
  })();

  /* ---------- Loox reviews (Disoven + Drena Strong) ---------- */
  (function () {
    var src = document.getElementById("dsrRevSrc");
    var grid = document.getElementById("dsrRevGrid");
    if (!src || !grid) return;
    function esc(s) { var d = document.createElement("div"); d.textContent = s; return d.innerHTML; }
    var nodes = src.querySelectorAll(".review");
    var seen = {}, revs = [];
    nodes.forEach(function (n) {
      var nm = (n.querySelector(".name") || {}).textContent || "";
      var tx = (n.querySelector(".review_text") || {}).textContent || "";
      nm = nm.trim(); tx = tx.replace(/\s+/g, " ").trim();
      if (tx.length < 40) return;                 // skip junk/too-short
      if (seen[tx]) return; seen[tx] = 1;          // dedupe
      revs.push({ n: nm || "Cliente", t: tx });
    });
    if (!revs.length) return;
    // light shuffle for variety, capped
    for (var i = revs.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = revs[i]; revs[i] = revs[j]; revs[j] = t; }
    revs = revs.slice(0, 150);
    var shown = 0, STEP = 9;
    function ini(n) { var c = (n || "?").trim().charAt(0).toUpperCase(); return c || "?"; }
    window.dsrRevMore = function () {
      var end = Math.min(shown + STEP, revs.length);
      for (var i = shown; i < end; i++) {
        var r = revs[i];
        var card = document.createElement("div");
        card.className = "dsr-rev-card";
        card.innerHTML =
          '<div class="dsr-rev-stars">★★★★★</div>' +
          '<div class="dsr-rev-txt">' + esc(r.t) + "</div>" +
          '<div class="dsr-rev-auth"><div class="dsr-rev-av">' + esc(ini(r.n)) + "</div>" +
          '<div><div class="dsr-rev-name">' + esc(r.n) + '</div><div class="dsr-rev-ver">✓ Acquisto verificato · Loox</div></div></div>';
        grid.appendChild(card);
      }
      shown = end;
      var btn = document.getElementById("dsrRevMore");
      if (btn) {
        if (shown >= revs.length) btn.style.display = "none";
        else btn.textContent = "Carica altre recensioni (" + (revs.length - shown) + ")";
      }
    };
    window.dsrRevMore();
  })();
})();
